<template>
	<!-- https://hktest.ricepon.com:64377/member-web/advert_item_list.html?advertId=341 -->
	<div class="content">
<van-notice-bar
  text="通知内容通知内容通知内容通知内容通知内容通知内容通知内容通知内容"
  left-icon="volume-o"
/>
	</div>
</template>

<script>
export default {
	data() {
		return {

		};
	},
	created() {

	},
	components: {
	}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/test/test.vue